import React, {Component} from "react";
import {Translate} from "react-i18nify";

import * as modelHelper from "../../../helpers/modelHelper";

import imgOrderNotification from "../../../resources/img/order-notification.gif";
import imgDispense from "../../../resources/img/svgicons/dispensing.svg";

import CloseButton from "../generic/CloseButton";
import Modal from "../generic/Modal";
import Button from "../generic/Button";

export default class OrderNotificationModal extends Component {
    handleOpenToDispenseOrdersClick = () => {
        this.props.openToDispenseOrders();
    };

    handleCloseModalClick = () => {
        this.props.closeModal();
    };

    render() {
        return (
            <Modal
                modalId={this.props.id}
                onClose={this.handleCloseModalClick}
                header={modelHelper.buildModalSection(<Translate value="ordering.newOrderReceived" />)}
                content={modelHelper.buildModalSection(
                    <img alt="new-order" src={imgOrderNotification} />,
                    "flex-align-center"
                )}
                footer={modelHelper.buildModalSection(
                    <React.Fragment>
                        {this.props.openToDispenseOrders && (
                            <Button
                                onClick={this.handleOpenToDispenseOrdersClick}
                                label={<Translate value="general.open" />}
                                svgBefore={imgDispense}
                            />
                        )}
                        <CloseButton onClick={this.handleCloseModalClick} />
                    </React.Fragment>,
                    "flex-gap-10px"
                )}
            />
        );
    }
}
